export default __webpack_public_path__ + "static/media/logo.ff05f492.png";